import { MbaConfiguration } from "models/mba"
import { http } from "./http"

export const fetchMbaConfig = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get(`mba-config/`, { searchParams }).json()

  return res as MbaConfiguration
}

export const patchMbaConfig = async (pld: MbaConfiguration) => {
  const res = await http.patch(`mba-config/${pld.id}`, { json: pld }).json()
  return res as MbaConfiguration
}

export const fetchCampaignMbaConfig = async (
  _key: string,
  level: string,
  id?: string,
) => {
  const res = await http.get(`${level}/${id}/unified-mba-config`).json()
  return res as MbaConfiguration
}

export const patchCampaignMbaConfig = async (
  pld: MbaConfiguration & { clientConfig?: string },
) => {
  const { id, clientConfig, ...rest } = pld
  const res = await http
    .patch(`campaigns/${id}/unified-mba-config`, {
      json: { ...rest, clientConfig },
    })
    .json()
  return res as MbaConfiguration
}

export const patchClientCampaignMbaConfig = async (
  pld: MbaConfiguration & { clientConfig?: string },
) => {
  const { id, clientConfig, ...rest } = pld
  const res = await http
    .patch(`client-agency-configs/${id}/unified-mba-config`, {
      json: { ...rest, clientConfig },
    })
    .json()
  return res as MbaConfiguration
}
